<figure [attr.id]="Id"></figure>
